import React from 'react';
import { ClipboardList, ChevronRight, LockKeyhole } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { SESSIONS_DESIGNER_ENABLED } from '../../utils/features';

export default function SessionsDesignerWidget({ isDark }) {
  const navigate = useNavigate();
  const locked = !SESSIONS_DESIGNER_ENABLED;
  return (
    <button
      type="button"
      disabled={locked}
      onClick={() => navigate('/session-planner')}
      data-testid="widget-session-planner"
      aria-labelledby="sessions-designer-widget-title"
      aria-describedby={locked ? 'sessions-designer-coming-soon' : undefined}
      className={`relative col-span-2 flex h-[82px] items-center rounded-3xl border p-5 text-left backdrop-blur-xl ${locked ? 'cursor-not-allowed' : 'transition hover:scale-[1.02] hover:shadow-2xl'} ${isDark ? (locked ? 'border-white/5 bg-[#1a1a2e]/30' : 'border-white/10 bg-[#1a1a2e]/80') : (locked ? 'border-[#493986]/5 bg-white/35' : 'border-[#493986]/10 bg-white/80 shadow-lg')}`}
    >
      <div className={`flex w-full items-center justify-between gap-3 ${locked ? 'opacity-50' : ''}`}>
        <div className="flex min-w-0 items-center gap-3">
          <div className="shrink-0 rounded-xl bg-violet-500/15 p-2.5"><ClipboardList size={20} className="text-violet-400" /></div>
          <div className="min-w-0">
            <h3 id="sessions-designer-widget-title" className={`font-semibold leading-5 ${isDark ? 'text-white' : 'text-[#493986]'}`}>Session Designer</h3>
            <p className={`mt-1 truncate text-xs ${isDark ? 'text-white/60' : 'text-[#493986]/60'}`}>Design your training sessions</p>
          </div>
        </div>
        {locked ? <LockKeyhole size={20} aria-hidden="true" className={`shrink-0 ${isDark ? 'text-white/60' : 'text-[#493986]/60'}`} /> : <ChevronRight size={20} aria-hidden="true" className="shrink-0 text-violet-400" />}
      </div>
      {locked && <span id="sessions-designer-coming-soon" className="pointer-events-none absolute -right-2 -top-3 -rotate-6 whitespace-nowrap rounded-lg border border-amber-100 bg-amber-300 px-3 py-1 text-[11px] font-bold leading-4 text-amber-950 shadow-md">Coming soon</span>}
    </button>
  );
}
